module.exports = __webpack_public_path__ + "img/contact-hero-garage.73b8f1f8.jpg";